var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#37bf86;stroke-miterlimit:10;stroke-width:31px;}.cls-2{fill:#37bf86;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    className: "cls-1",
    cx: 150,
    cy: 150,
    r: 129
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Bolt",
    className: "cls-2",
    d: "M212.59885,140.87517l-81.86,99.54539,6.42042-58.06809H87.40115l101.12149-122.773L161.2358,140.87517Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditPower);
export default __webpack_public_path__ + "static/media/credit-power.22670abe44e5b213f39b2364c3f38655.svg";
export { ForwardRef as ReactComponent };